<template>
  <portlet
          :icon="'fal fa-folder-open'"
          :title="'SMS historie'"
  >
    <template slot="portletBody">

      <div v-if="getSmsHistory.length   ">
        <button class="m-show-lg btn btn-secondary w-100 mb-4" @click="filterOpen = !filterOpen">
          <i class="far mr-3" :class="{'fa-filter': !filterOpen, 'fa-times': filterOpen }"></i>
          <template v-if="!filterOpen">
            Filter Sms
          </template>
          <template v-else>
            Sluit filter
          </template>
        </button>
        <div class="row dataTable-filters mb-5" :class="filterOpenClass">
          <div class="col-md-4 col-xl-2">
            <div class="dropdown">
              <button class="btn btn-primary dropdown-toggle" type="button">
                <span>{{customFilters[0].options.values.length < 2 ? 'Kandidaat' : 'Kandidaten'}}  ({{customFilters[0].options.values.length}})</span>
              </button>
              <div class="dropdown-menu">
                <input class="form-control mb-3" type="text" placeholder="Zoeken.."
                       v-model="searchName">
                <div class="option-wrapper">
                  <div class="custom-control custom-checkbox"
                       v-for="(candidate, index) in getNames(searchName)"
                       :key="candidate+'-'+index">
                    <input v-model="customFilters[0].options.values"
                           :value="candidate.id"
                           type="checkbox"
                           :id="candidate.fullName+'-'+index"
                           class="custom-control-input"
                    >
                    <label class="custom-control-label" :for="candidate.fullName+'-'+index">
                      <span>{{candidate.firstName}} {{candidate.lastName}}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4 col-xl-2">
            <date-range-picker
                    ref="picker"
                    v-model="picker"
                    opens="center"
                    :showDropdowns="true"
                    :autoApply="true"
                    :locale-data="this.locales"
                    :ranges="this.ranges"
                    @update="updateDateRange"
            >
              <template slot="input" slot-scope="picker">
                <i class="fad fa-calendar"></i> <label>Bereik afspraken</label>
              </template>
            </date-range-picker>
          </div>
        </div>

        <datatables
                :tableClass="tableClass"
                :rows="getSmsHistory"
                :columns="getColumns()"
                tableID="sms-dt"
                :deleteFunction="deleteAppointment"
                routerLinkClass="dt-router-link"
                :customFilters="customFilters"
                :tableInitOptions="tableInitOptions"
        ></datatables>
      </div>
      <div v-else>
        Er is niets gevonden.
      </div>
    </template>
  </portlet>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {dataTables} from '../../components/mixins/dataTables';
  import {swalModals} from '../../components/mixins/swalModals';


  export default {
    props: ['candidateId'],
    mixins: [dataTables, swalModals],
    data() {
      return {
        candidate: null,
        filterOpen: false,
        filterOpenClass: 'm-hide-lg',
        searchName: '',
        searchCompany: '',
        picker: {
          startDate: null,
          endDate: null
        },
        locales: {
          direction: 'ltr',
          format: moment.localeData().longDateFormat('L'),
          separator: ' - ',
          applyLabel: 'Opslaan',
          cancelLabel: 'Annuleren',
          weekLabel: 'W',
          customRangeLabel: 'Bereik afspraken',
          daysOfWeek: moment.weekdaysMin(),
          monthNames: moment.monthsShort(),
          firstDay: moment.localeData().firstDayOfWeek()
        },
        ranges: {
          'Vandaag': [moment().startOf('day'), moment().endOf('day')],
          'Gisteren': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
          'Deze week': [moment().startOf('week'), moment().endOf('week')],
          'Deze maand': [moment().startOf('month'), moment().endOf('month')],
          'Dit jaar': [moment().startOf('year'), moment().endOf('year')],
          'Vorige week': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
          'Vorige maand': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
          'Toekomst': [moment().startOf('day'), moment().add(100, 'years').endOf('day')]
        },
        tableInitOptions: {
          order: [[1, 'desc']],
        },
        customFilters: [
          {
            filter: 'arrayContains',
            keyToFilter: 'candidateId',
            options: {
              keyToFilter: null,
              values: []
            }
          },
          {
            filter: 'arrayContains',
            keyToFilter: 'customerId',
            options: {
              keyToFilter: null,
              values: []
            }
          },
          {
            filter: 'dateRangeFilter',
            keyToFilter: 'created_at',
            options: {
              range: {
                min: moment().subtract(10, 'days').startOf('day').toDate(),
                max: moment()
              }
            }
          }
        ]
      };
    },
    methods: {
      getNames(searchName) {
        return this.getCandidates.filter(candidate => `${candidate.firstName} ${candidate.lastName}`.toLowerCase().indexOf(searchName.toLowerCase()) > -1);
      },
      getColumns() {
        let self = this;
        return [

          {
            data: null, name: 'Verzonden door', visible: true, searchable: true, orderable: true,
            render(data) {
              return data.sentBy.firstname + ' ' + data.sentBy.lastname;
            }
          },
          {
            data: null, name: 'Datum', visible: true, searchable: true, orderable: true,
            render(data) {
              return moment(data.created_at).format('DD/MM/YY HH:mm');
            }
          },
          {
            data: null, name: 'SMS', visible: true, searchable: true, orderable: true,
            render(data) {
              return data.message;
            }
          },
          {
            data: null, name: 'Status', visible: true, searchable: true, orderable: true,
            render(data) {
              if(data.status === 'pending'){
                return `<i class="far fa-check" style=" font-size:20px;"></i>`
              }
              if(data.status === 'sent'){
                return `<i class="far fa-check-double" style="font-size:20px;color:green"></i>`
              }else{
                return  `<i class="far fa-check" style="color:red;font-size:20px;"></i>`
              }

            }
          },
          {
            data: null, name: 'Verzonden aan', visible: true, searchable: true, orderable: true,
            responsivePriority: 9999,
            render(data) {
              let candiates = data.candidates;
              return _.map(candiates, candidateData => {
                let candidate = self.getCandidate(candidateData.id);
                if(candidate) {
                  return `${candidate.firstName}  ${candidate.lastName}`;
                }
              }).join('<br>');
            },
            class: 'none align-left;'
          },
          {
            data: null, name: 'Incorrecte nummers', visible: true, searchable: true, orderable: true,
            responsivePriority: 9999,
            render(data) {
              let candiates = data.failedNumbers;
              return _.map(candiates, candidateData => {
                let candidate = self.getCandidate(candidateData);
                if(candidate) {
                  return `<a class="dt-router-link" data-to="/candidates/${candidate.id}">     ${candidate.firstName}  ${candidate.lastName}</a>`;
                }
              }).join('<br>');
            },
            class: 'none align-left;'
          }
          // {
          //   data: null, name: 'Opties', searchable: false, orderable: false,
          //   render(data) {
          //     if(data.status == 'pending')
          //       return '<a class="delete action-icon dt-router-link" data-id="' + data.id + '"><i title="Verwijder" class="far fa-trash-alt delete"></i></a>';
          //   }
          // }
        ];
      },
      deleteAppointment(appointment) {
        let candidate = this.getCandidate(appointment.candidateId);
        let startDate = moment(appointment.startDate).format('DD-MM-YYYY');
        let startTime = moment(`2000-01-01 ${appointment.startTime}`).format('HH:MM');
        let endTime = moment(`2000-01-01 ${appointment.endTime}`).format('HH:MM');
        let company = this.getCustomer(appointment.customerId).name;

        this.swalDeleteAppointment(candidate ? `${candidate.firstName} ${candidate.lastName}` : 'de verwijderde kandidaat', startDate, startTime, endTime, company).then(result => {
          if(result.value) {
            this.$store.dispatch('appointments/delete', appointment.id).then(() => {
              this.renderComponent();
              this.$toasted.global.successRequest({
                message: 'Afspraak verwijderd'
              });
            });
          }
        });
      },
      searchByName() {
        return this.getCandidateFullName.filter((search) => {
          return search.fullName.toLowerCase().indexOf(this.searchName.toLowerCase()) >= 0;
        });
      },
      /**
       * Set date filters with new values from date range picker and filter table
       * @param dateRange
       */
      updateDateRange(dateRange) {
        this.customFilters[2].options.range.min = moment(dateRange.startDate).startOf('day').toDate();
        this.customFilters[2].options.range.max = moment(dateRange.endDate).endOf('day').toDate();
      }
    },
    computed: {
      ...mapGetters('smsHistory', ['getSmsHistory', 'getSms']),
      ...mapGetters('candidates', ['getCandidates', 'getCandidate', 'getCandidateFullName'])
    },
    watch: {
      'filterOpen': function (value) {
        this.filterOpenClass = value ? 'm-show-flex-lg' : 'm-hide-lg';
      }
    },
    created() {
      moment().locale('nl');
    }
  };
</script>
<style>
  .dtr-details {
    text-align: left;
  }

  .deletedCandidate {
    color: red;
  }
</style>
